import axios from '../components/shared/axios';

const baseURL = process.env.REACT_APP_BACKEND_URL;

export const getComments = async (
  paginationParams = {},
  otherParams = {}
) => {
  return await axios.get(`${baseURL}/comments`, {
    params: {
      ...paginationParams,
      ...otherParams
    }
  });
};

export const updateComment = async (params) => {
  return await axios.post(`${baseURL}/update-comment`, params);
};

export const statuses = [
  'all',
  'pending',
  'deleted',
  'approved',
  'rejected'
];
export const statusActionItems = {
  pending: ['Accept', 'Reject'],
  deleted: [],
  approved: ['Reject'],
  rejected: []
};

export const actionItemsToStatus = {
  Accept: 'approved',
  Reject: 'rejected',
  Retrieve: 'approved',
  Approve: 'approved'
};
